import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { LeftpanelComponent } from './leftpanel/leftpanel.component';
import { AppSubMenuComponent } from './leftpanel/submenu.component';
import { RouterModule, Routes } from '@angular/router';
import { HeaderContentComponent } from './content/header/headercontent.component';
import { PaginadorComponent } from './paginador/paginador.component';

const routes: Routes = [
    { path: '', redirectTo: 'layout/topbar', pathMatch: 'full' },
    { path: 'layout/footer', component: FooterComponent },
];
@NgModule({
    declarations: [
        FooterComponent,
        TopbarComponent,
        LeftpanelComponent,
        HeaderContentComponent,
        AppSubMenuComponent,
        PaginadorComponent,
    ],
    imports: [CommonModule, RouterModule.forChild(routes)],
    exports: [
        FooterComponent,
        TopbarComponent,
        LeftpanelComponent,
        AppSubMenuComponent,
        RouterModule,
        HeaderContentComponent,
        PaginadorComponent,
    ],
})
export class LayoutModule {}
